import { Loader2 } from 'lucide-react';
import React from 'react';

export type SectionPreviewPaneProps = {
    visible: boolean;
    iframeRef: React.RefObject<HTMLIFrameElement | null>;
    iframeURL: string;
    previewError: string | null;
    connectionError?: string | null;
    className?: string;
    isRefreshing?: boolean;
};

/**
 * Shared wrapper for the live-preview iframe used by every page that hosts a TiptapEditor
 * alongside a preview toggle. Keeps the iframe mounted (so the penpal connection survives
 * edit/preview toggles) and hides it via `hidden` when `visible` is false.
 */
export const SectionPreviewPane: React.FC<SectionPreviewPaneProps> = ({
    visible,
    iframeRef,
    iframeURL,
    previewError,
    connectionError,
    className,
    isRefreshing = false,
}) => (
    <div className={`relative h-full w-full ${visible ? '' : 'hidden'}${className ? ` ${className}` : ''}`}>
        {previewError && <div className="w-full bg-red-50 p-2 text-center text-sm text-red-500">{previewError}</div>}
        {connectionError && (
            <div className="w-full bg-yellow-50 p-2 text-center text-sm text-yellow-600">Connection error: {connectionError}</div>
        )}
        <iframe
            ref={iframeRef}
            src={iframeURL}
            title="Section Live Preview"
            className="h-full w-full border-0"
        />
        {visible && isRefreshing && (
            <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/70">
                <Loader2 className="text-muted-foreground mb-2 h-8 w-8 animate-spin" />
            </div>
        )}
    </div>
);
